import React from 'react';
import cx from 'classnames';
import FormattedMessage from 'components/FormattedMessage/FormattedMessage';
import styles from './PriceDescription.css';
export default function PriceDescription(props) {
    let { priceDescription, containerClass, headerClass, priceDescriptionClass, imageClass } = props;
    if (!priceDescription) {
        return null;
    }
    return (<FormattedMessage title={props.priceDescription.title} data={props.priceDescription.data} containerClass={cx(styles['price-description'], containerClass)} titleClass={cx(styles['header'], headerClass)} contentClass={cx(styles['plus-price-details'], priceDescriptionClass)} imageClass={cx(styles['coin-icon'], imageClass)} imageSize={10}/>);
}
